import * as React from "react";
const SvgPencil = (props) => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m11.694 3.36 2.946 2.946M12.943 2.11a2.083 2.083 0 0 1 2.947 2.946L4.417 16.53H1.5v-2.976L12.944 2.11Z"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPencil;
